<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header d-flex justify-content-between align-items-center">
            <h2>Arch Transaction List</h2>
          </div>
          <!-- Transaction Listing-->
          <div class="body pt-0">
            <!-- Filters/Buttons -->
            <div class="chart-top-action d-lg-flex justify-content-end py-3">
              <!-- SearchBox Filters -->
              <div class="mr-0 mr-lg-3 action-top-search">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="search.keywords"
                    placeholder="Enter Keywords"
                    aria-label="Enter Keywords"
                    aria-describedby="search-transactions"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text" id="search-mail">
                      <i class="icon-magnifier"></i>
                    </span>
                  </div>
                </div>
              </div>
              <!-- Toggle Filter Button -->
              <div class="fliter-main mr-auto mt-3 mt-lg-0">
                <b-button
                  class="fliter-btn btn-lg btn-mw"
                  :variant="isVisibleFilter ? 'primary' : 'outline-primary'"
                  @click="isVisibleFilter = !isVisibleFilter"
                >
                  Filter
                  <i class="fa fa-filter" aria-hidden="true"></i>
                </b-button>
              </div>
              <!-- Toggle Filter Collapse -->
              <b-collapse
                id="fliter-collapse"
                class="fliter-collapse"
                v-model="isVisibleFilter"
              >
                <div class="d-flex justify-content-between p-3">
                  <div class="form-group datepicker">
                    <b-input-group>
                      <div class="input-group-prepend">
                        <span class="input-group-text">From</span>
                        <span
                          class="input-group-text"
                          @click="$refs.birthdate.showCalendar()"
                        >
                          <i class="icon-calendar"></i>
                        </span>
                        <datepicker
                          class="form-control"
                          ref="birthdate"
                          v-model="search.from"
                          :bootstrap-styling="false"
                          placeholder=""
                          :typeable="true"
                        ></datepicker>
                      </div>
                    </b-input-group>
                  </div>
                  <div class="form-group datepicker">
                    <b-input-group>
                      <div class="input-group-prepend">
                        <span class="input-group-text">To</span>
                        <span
                          class="input-group-text"
                          @click="$refs.birthdate1.showCalendar()"
                        >
                          <i class="icon-calendar"></i>
                        </span>
                        <datepicker
                          class="form-control"
                          ref="birthdate1"
                          v-model="search.to"
                          :bootstrap-styling="false"
                          placeholder=""
                          :typeable="true"
                        ></datepicker>
                      </div>
                    </b-input-group>
                  </div>
                  <div class="form-group form-select single-multiselect">
                    <span class="float-label">
                      <multiselect
                        placeholder="Select Type"
                        v-model="search.type"
                        :show-labels="false"
                        :options="typeoption"
                        :searchable="true"
                      ></multiselect>
                    </span>
                    <div class="line"></div>
                  </div>
                  <div class="form-group">
                    <input
                      class="form-control"
                      type="text"
                      v-model="search.companyname"
                      placeholder="Company Name"
                    />
                    <div class="line"></div>
                  </div>
                </div>
                <div class="d-flex justify-content-between p-3">
                  <div class="form-group form-select single-multiselect">
                    <span class="float-label">
                      <multiselect
                        placeholder="Transaction Status"
                        v-model="search.tstatus"
                        :show-labels="false"
                        :options="transactionStatus"
                        :searchable="true"
                      ></multiselect>
                    </span>
                    <div class="line"></div>
                  </div>
                  <div class="form-group">
                    <input
                      class="form-control"
                      type="text"
                      v-model="search.mobileMoneyNetwork"
                      placeholder="Mobile Money Network"
                    />
                    <div class="line"></div>
                  </div>
                  <div class="form-group">
                    <input
                      class="form-control"
                      type="text"
                      v-model="search.bankName"
                      placeholder="Bank Name"
                    />
                    <div class="line"></div>
                  </div>
                </div>
                <div class="d-flex justify-content-end p-3">
                  <div class="form-group mr-3">
                    <button
                      class="btn btn-primary h-100"
                      @click="isVisibleFilter = true"
                    >
                      Apply
                    </button>
                  </div>
                  <div class="form-group">
                    <button
                      class="btn btn-outline-danger h-100"
                      @click="isVisibleFilter = false"
                    >
                      Cancel/Clear
                    </button>
                  </div>
                </div>
              </b-collapse>
            </div>
            <!-- All Transaction List -->
            <b-table
              ref="transactionTable"
              responsive
              table-class="mb-0 table-custom border transaction-list-table"
              head-variant="light"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #cell(srccountry)="data">
                <div class="align-items-center d-flex justify-content-center">
                  <span :class="data.value.flagClass"></span>
                </div>
              </template>
              <template #cell(sender)="data">
                <strong>
                  <router-link
                    class="font-color"
                    to="/customer/edit"
                    target="_blank"
                  >
                    {{ data.value.name.substring(0, 19) }}
                    <span v-if="data.value.name.length > 19">...</span>
                  </router-link>
                </strong>
                <small class="text-grey d-block">{{ data.value.group }}</small>
              </template>
              <template #cell(recver)="data">
                <span :title="data.value.name">
                  <router-link
                    class="font-color"
                    to="/beneficiary/edit"
                    target="_blank"
                  >
                    {{ data.value.name.substring(0, 19) }}
                    <span v-if="data.value.name.length > 19">...</span>
                  </router-link>
                </span>
              </template>
              <template #cell(refno)="data">
                <span>
                  <i :class="data.value.class" class="mr-1"></i>
                  <router-link
                    class="font-color"
                    to="/transaction/edit"
                    target="_blank"
                  >
                    {{ data.value.ref }}
                  </router-link>
                </span>
              </template>
              <template #cell(datetime)="data">
                <strong>{{ data.value.date }}</strong>
                <small class="text-grey d-block">{{ data.value.time }}</small>
              </template>
              <template #cell(accno)="data">
                <div class="align-items-center d-flex">
                  <span>
                    <i :class="data.value.type" class="mr-1"></i>
                    <strong>{{ data.value.acc }}</strong>
                    <br />
                    <span class="text-grey d-block">{{ data.value.no }}</span>
                  </span>
                </div>
              </template>
              <template #cell(srcamount)="data">
                <div
                  class="d-flex align-items-start justify-content-end amount-arrow"
                >
                  <p class="mb-0 text-right">
                    <span>{{ data.value.amount }}</span>
                    <span class="d-block">{{ data.value.destamount }}</span>
                  </p>
                </div>
              </template>
              <template #cell(processor)="data">
                <div class="text-center">{{ data.value }}</div>
              </template>
              <template #cell(status)="data">
                <p class="function-badge badge-group-table mb-0 text-center">
                  <span class="badge ml-0 d-block" :class="data.value.class">
                    {{ data.value.name }}
                  </span>
                </p>
              </template>
              <template #cell(action)="data">
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  right
                  variant="outline-primary"
                  v-if="data.value.name == 'Awaiting Funds'"
                >
                  <b-dropdown-item>Payment Received</b-dropdown-item>
                  <b-dropdown-item>Hold</b-dropdown-item>
                  <b-dropdown-item>Download Receipt</b-dropdown-item>
                  <b-dropdown-item>Share By Email</b-dropdown-item>
                </b-dropdown>
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  right
                  variant="outline-primary"
                  v-if="data.value.name == 'Recipient Paid'"
                >
                  <b-dropdown-item>Download Receipt</b-dropdown-item>
                  <b-dropdown-item>Share By Email</b-dropdown-item>
                </b-dropdown>
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  right
                  variant="outline-primary"
                  v-if="data.value.name == 'Sent for Payment'"
                >
                  <b-dropdown-item>GT</b-dropdown-item>
                  <b-dropdown-item>NSANO</b-dropdown-item>
                  <b-dropdown-item>ACH</b-dropdown-item>
                  <b-dropdown-item>AZA-FIN</b-dropdown-item>
                  <b-dropdown-item>GTdirect-112</b-dropdown-item>
                  <b-dropdown-item>PGL</b-dropdown-item>
                  <b-dropdown-item>RIPPLE-NET</b-dropdown-item>
                  <b-dropdown-item>Hold</b-dropdown-item>
                  <b-dropdown-item>Re-assign</b-dropdown-item>
                  <b-dropdown-item>Download Receipt</b-dropdown-item>
                  <b-dropdown-item>Share By Email</b-dropdown-item>
                </b-dropdown>
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  right
                  variant="outline-primary"
                  v-if="data.value.name == 'Incomplete'"
                >
                  <b-dropdown-item href="/transaction/details">
                    View
                  </b-dropdown-item>
                  <b-dropdown-item>Cancel</b-dropdown-item>
                  <b-dropdown-item>Download Receipt</b-dropdown-item>
                  <b-dropdown-item>Share By Email</b-dropdown-item>
                </b-dropdown>
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  right
                  variant="outline-primary"
                  v-if="data.value.name == 'Cancelled'"
                >
                  <b-dropdown-item href="/transaction/details">
                    View
                  </b-dropdown-item>
                  <b-dropdown-item>Download Receipt</b-dropdown-item>
                  <b-dropdown-item>Share By Email</b-dropdown-item>
                </b-dropdown>
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  right
                  variant="outline-primary"
                  v-if="data.value.name == 'Created'"
                >
                  <b-dropdown-item href="/transaction/details">
                    View
                  </b-dropdown-item>
                  <b-dropdown-item>Cancel</b-dropdown-item>
                  <b-dropdown-item>Hold</b-dropdown-item>
                  <b-dropdown-item>Download Receipt</b-dropdown-item>
                  <b-dropdown-item>Share By Email</b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="py-3 d-flex align-items-center justify-content-between table-pagination"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  hide-goto-end-buttons
                  hide-ellipsis
                  prev-text="Previous page"
                  next-text="Next page"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go to Page</span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card card-top-line no-shadow">
          <div class="header">
            <h2>Total Number Of Transactions: 20</h2>
            <p>
              Note: The number of transactions in the reports is limited to 100.
            </p>
          </div>
          <div class="body">
            <div class="row clearfix row-deck">
              <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                <div class="card no-shadow card-icon">
                  <div
                    class="card-body d-flex align-items-start border-left border-2 border-primary"
                  >
                    <div class="svg-box">
                      <svg
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          class="fill"
                          d="M22.5 1.875C22.9973 1.875 23.4742 2.07254 23.8258 2.42417C24.1775 2.77581 24.375 3.25272 24.375 3.75V26.25C24.375 26.7473 24.1775 27.2242 23.8258 27.5758C23.4742 27.9275 22.9973 28.125 22.5 28.125H7.5C7.00272 28.125 6.52581 27.9275 6.17417 27.5758C5.82254 27.2242 5.625 26.7473 5.625 26.25V3.75C5.625 3.25272 5.82254 2.77581 6.17417 2.42417C6.52581 2.07254 7.00272 1.875 7.5 1.875H22.5ZM7.5 0C6.50544 0 5.55161 0.395088 4.84835 1.09835C4.14509 1.80161 3.75 2.75544 3.75 3.75V26.25C3.75 27.2446 4.14509 28.1984 4.84835 28.9017C5.55161 29.6049 6.50544 30 7.5 30H22.5C23.4946 30 24.4484 29.6049 25.1516 28.9017C25.8549 28.1984 26.25 27.2446 26.25 26.25V3.75C26.25 2.75544 25.8549 1.80161 25.1516 1.09835C24.4484 0.395088 23.4946 0 22.5 0L7.5 0Z"
                        ></path>
                        <path
                          class="fill"
                          d="M10.9092 13.7188C11.0549 15.3596 12.3985 16.5241 14.4439 16.6747V17.8717H15.4706V16.6747C17.705 16.4985 19.091 15.2592 19.091 13.4264C19.091 11.8613 18.1588 10.9557 16.1813 10.4458L15.4706 10.2618V6.5193C16.575 6.62758 17.3202 7.22212 17.5082 8.10999H18.9552C18.7918 6.53505 17.4393 5.40503 15.4706 5.28002V4.09094H14.4439V5.30463C12.5353 5.53103 11.2252 6.75358 11.2252 8.4112C11.2252 9.84243 12.176 10.8553 13.8445 11.2825L14.4449 11.442V15.4098C13.3139 15.2425 12.5353 14.6224 12.3473 13.7188H10.9092ZM14.2471 9.94283C13.2204 9.68395 12.6721 9.13075 12.6721 8.35214C12.6721 7.42293 13.3651 6.73684 14.4439 6.55277V9.99303L14.2471 9.94382V9.94283ZM15.8132 11.7855C17.08 12.1035 17.6361 12.6311 17.6361 13.5268C17.6361 14.6066 16.8231 15.3262 15.4706 15.4354V11.6999L15.8132 11.7845V11.7855Z"
                        ></path>
                        <path
                          class="fill"
                          d="M15 26.25C15.4973 26.25 15.9742 26.0525 16.3258 25.7008C16.6775 25.3492 16.875 24.8723 16.875 24.375C16.875 23.8777 16.6775 23.4008 16.3258 23.0492C15.9742 22.6975 15.4973 22.5 15 22.5C14.5027 22.5 14.0258 22.6975 13.6742 23.0492C13.3225 23.4008 13.125 23.8777 13.125 24.375C13.125 24.8723 13.3225 25.3492 13.6742 25.7008C14.0258 26.0525 14.5027 26.25 15 26.25Z"
                        ></path>
                      </svg>
                    </div>
                    <div class="ml-3">
                      <h6 class="mb-1 font-15 text-muted font-weight-normal">
                        Total Source Amount:
                      </h6>
                      <h5 class="mb-0">$10,033,900.99</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                <div class="card no-shadow card-icon">
                  <div
                    class="card-body d-flex align-items-start border-left border-2 border-primary"
                  >
                    <div class="svg-box">
                      <svg
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          class="fill"
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M6.76147 3.17286C4.79029 3.17286 3.17261 4.79077 3.17261 6.76502V7.08222C4.12786 6.22872 5.38629 5.7085 6.76147 5.7085H18.393C17.9883 4.22942 16.6088 3.17286 14.9247 3.17286H6.76147ZM20.2462 5.7085C19.8085 3.16458 17.5532 1.36353 14.9247 1.36353H6.76147C3.78977 1.36353 1.36328 3.79276 1.36328 6.76502V23.1015C1.36328 26.0738 3.78977 28.503 6.76147 28.503H23.2377C26.1248 28.503 28.6359 26.0835 28.6359 23.1015V20.9406C28.636 20.9366 28.636 20.9325 28.636 20.9284V11.7099C28.636 11.7059 28.636 11.7018 28.6359 11.6977V11.11C28.6359 8.13773 26.2094 5.7085 23.2377 5.7085H20.2462ZM19.3582 7.51783C19.378 7.51913 19.3981 7.51979 19.4182 7.51979C19.4384 7.51979 19.4585 7.51913 19.4783 7.51783H23.2377C25.1065 7.51783 26.6575 8.97196 26.8137 10.8053H21.8898C19.2064 10.8053 17.0907 13.021 17.0907 15.6072V17.0312C17.0907 19.7149 19.3039 21.8331 21.8898 21.8331H26.8266V23.1015C26.8266 25.0661 25.1438 26.6937 23.2377 26.6937H6.76147C4.79029 26.6937 3.17261 25.0758 3.17261 23.1015V11.11C3.17261 9.13575 4.79029 7.51783 6.76147 7.51783H19.3582ZM26.8266 12.6146V20.0238H21.8898C20.2817 20.0238 18.9 18.6944 18.9 17.0312V15.6072C18.9 13.9963 20.2294 12.6146 21.8898 12.6146H26.8266ZM23.0879 15.6137C22.7609 15.6137 22.4947 15.8791 22.4947 16.2079C22.4947 16.5368 22.7609 16.8022 23.0879 16.8022C23.4149 16.8022 23.6811 16.5368 23.6811 16.2079C23.6811 15.8791 23.4149 15.6137 23.0879 15.6137ZM20.6854 16.2079C20.6854 14.8811 21.7604 13.8043 23.0879 13.8043C24.4154 13.8043 25.4904 14.8811 25.4904 16.2079C25.4904 17.5348 24.4154 18.6116 23.0879 18.6116C21.7604 18.6116 20.6854 17.5348 20.6854 16.2079Z"
                          fill="white"
                        ></path>
                      </svg>
                    </div>
                    <div class="ml-3">
                      <h6 class="mb-1 font-15 text-muted font-weight-normal">
                        PayAngel Wallet:
                      </h6>
                      <h5 class="mb-0">$10,033.99</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                <div class="card no-shadow card-icon">
                  <div
                    class="card-body d-flex align-items-start border-left border-2 border-primary"
                  >
                    <div class="svg-box">
                      <svg
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          class="fill"
                          d="M15 1.78125L27.3937 7.5H29.0625C29.3111 7.5 29.5496 7.59877 29.7254 7.77459C29.9012 7.9504 30 8.18886 30 8.4375V12.1875C30 12.4361 29.9012 12.6746 29.7254 12.8504C29.5496 13.0262 29.3111 13.125 29.0625 13.125H28.125V26.25C28.3341 26.2501 28.5372 26.32 28.702 26.4488C28.8668 26.5776 28.9838 26.7577 29.0344 26.9606L29.9719 30.7106C30.0063 30.8488 30.0089 30.993 29.9793 31.1323C29.9497 31.2716 29.8888 31.4023 29.8011 31.5146C29.7135 31.6268 29.6014 31.7176 29.4734 31.78C29.3454 31.8425 29.2049 31.875 29.0625 31.875H0.9375C0.795096 31.875 0.654572 31.8425 0.526595 31.78C0.398617 31.7176 0.286549 31.6268 0.198896 31.5146C0.111243 31.4023 0.0503098 31.2716 0.0207204 31.1323C-0.00886906 30.993 -0.00633678 30.8488 0.028125 30.7106L0.965625 26.9606C1.01623 26.7577 1.13323 26.5776 1.298 26.4488C1.46278 26.32 1.66588 26.2501 1.875 26.25V13.125H0.9375C0.68886 13.125 0.450403 13.0262 0.274587 12.8504C0.0987721 12.6746 0 12.4361 0 12.1875V8.4375C0 8.18886 0.0987721 7.9504 0.274587 7.77459C0.450403 7.59877 0.68886 7.5 0.9375 7.5H2.60625L15 1.78125ZM7.08 7.5H22.9181L15 3.84375L7.08 7.5ZM3.75 13.125V26.25H5.625V13.125H3.75ZM7.5 13.125V26.25H12.1875V13.125H7.5ZM14.0625 13.125V26.25H15.9375V13.125H14.0625ZM17.8125 13.125V26.25H22.5V13.125H17.8125ZM24.375 13.125V26.25H26.25V13.125H24.375ZM28.125 11.25V9.375H1.875V11.25H28.125ZM27.3937 28.125H2.60625L2.1375 30H27.8625L27.3937 28.125Z"
                        ></path>
                      </svg>
                    </div>
                    <div class="ml-3">
                      <h6 class="mb-1 font-15 text-muted font-weight-normal">
                        Bank Account:
                      </h6>
                      <h5 class="mb-0">$10,900.99</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                <div class="card no-shadow card-icon">
                  <div
                    class="card-body d-flex align-items-start border-left border-2 border-primary"
                  >
                    <div class="svg-box">
                      <svg
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          class="fill"
                          d="M26.25 17.8125C26.25 18.8071 25.8549 19.7609 25.1516 20.4641C24.4484 21.1674 23.4946 21.5625 22.5 21.5625C21.5054 21.5625 20.5516 21.1674 19.8484 20.4641C19.1451 19.7609 18.75 18.8071 18.75 17.8125C18.75 16.8179 19.1451 15.8641 19.8484 15.1609C20.5516 14.4576 21.5054 14.0625 22.5 14.0625C23.4946 14.0625 24.4484 14.4576 25.1516 15.1609C25.8549 15.8641 26.25 16.8179 26.25 17.8125ZM15 28.5C15 30 16.5 30 16.5 30H28.5C28.5 30 30 30 30 28.5C30 27 28.5 22.5 22.5 22.5C16.5 22.5 15 27 15 28.5Z"
                        ></path>
                        <path
                          class="fill"
                          d="M3.75 3.75C2.75544 3.75 1.80161 4.14509 1.09835 4.84835C0.395088 5.55161 0 6.50544 0 7.5L0 22.5C0 23.4946 0.395088 24.4484 1.09835 25.1517C1.80161 25.8549 2.75544 26.25 3.75 26.25H13.5806C13.8094 25.6388 14.1337 24.9975 14.5669 24.375H3.75C3.25272 24.375 2.77581 24.1775 2.42417 23.8258C2.07254 23.4742 1.875 22.9973 1.875 22.5V7.5C1.875 7.00272 2.07254 6.52581 2.42417 6.17417C2.77581 5.82254 3.25272 5.625 3.75 5.625H26.25C26.7473 5.625 27.2242 5.82254 27.5758 6.17417C27.9275 6.52581 28.125 7.00272 28.125 7.5V22.1438C28.7869 22.575 29.355 23.0738 29.8312 23.6119C29.9419 23.2613 30 22.8881 30 22.5V7.5C30 6.50544 29.6049 5.55161 28.9016 4.84835C28.1984 4.14509 27.2446 3.75 26.25 3.75H3.75Z"
                        ></path>
                        <path
                          class="fill"
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M9.64745 16.0876C9.43785 16.0877 9.24875 15.9617 9.16814 15.7683C9.08752 15.5748 9.13121 15.3518 9.27889 15.2031C9.48474 15.008 9.80721 15.008 10.0131 15.2031C10.1115 15.3004 10.1668 15.4332 10.1664 15.5716C10.1664 15.8159 10.3644 16.0139 10.6087 16.0139C10.8529 16.0139 11.0509 15.8159 11.0509 15.5716C11.0514 14.9164 10.5966 14.3489 9.95704 14.2065L9.9423 13.9323C9.9423 13.688 9.74428 13.49 9.50002 13.49C9.25576 13.49 9.05775 13.688 9.05775 13.9323V14.3038C8.45741 14.5782 8.13018 15.2345 8.27232 15.8791C8.41445 16.5237 8.98738 16.9816 9.64745 16.9781C9.96331 16.9796 10.2284 17.2166 10.2651 17.5304C10.3019 17.8441 10.0989 18.1359 9.79192 18.2105H9.51182C9.20087 18.1444 8.9898 17.8545 9.02237 17.5383C9.04638 17.2958 8.8697 17.0795 8.62727 17.0547C8.51047 17.0416 8.3933 17.0761 8.30228 17.1504C8.21126 17.2248 8.1541 17.3327 8.14372 17.4498C8.07568 18.1099 8.44829 18.7365 9.0607 18.9919C9.08046 19.1991 9.24295 19.364 9.44985 19.3868C9.65676 19.4097 9.85129 19.2842 9.91576 19.0862C10.6866 18.9484 11.2241 18.2439 11.1535 17.464C11.0828 16.6841 10.4276 16.0877 9.6445 16.0906L9.64745 16.0876Z"
                        ></path>
                        <path
                          class="fill"
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M15.1907 18.9261C15.0728 17.6022 14.4978 13.3505 11.9474 11.7524V11.7347L12.8319 9.3759C12.9334 9.10433 12.8953 8.80027 12.7301 8.56207C12.5648 8.32388 12.2933 8.18179 12.0034 8.18176H7.28579C6.99588 8.18179 6.72438 8.32388 6.55912 8.56207C6.39385 8.80027 6.3558 9.10433 6.45727 9.3759L7.34182 11.7347V11.7524C4.78547 13.3505 4.21052 17.6022 4.09847 18.9261C4.04907 19.496 4.24046 20.0605 4.62625 20.4829C5.01804 20.912 5.57254 21.156 6.15357 21.1551H13.1268C13.7078 21.156 14.2623 20.912 14.6541 20.4829C15.0431 20.062 15.2377 19.4973 15.1907 18.9261ZM7.28873 9.06732H12.0063L11.1218 11.4261H8.17328L7.28873 9.06732ZM13.1327 20.2714H6.16251C5.83377 20.2723 5.51955 20.136 5.29565 19.8953C5.07174 19.6546 4.95845 19.3314 4.98311 19.0035C5.2013 16.5474 6.09469 13.2628 8.17043 12.3105H11.1189C13.1829 13.2658 14.091 16.5474 14.3062 19.0035C14.3308 19.3303 14.2183 19.6526 13.9957 19.8931C13.7731 20.1336 13.4605 20.2707 13.1327 20.2714Z"
                        ></path>
                        <path
                          class="fill"
                          d="M15.1907 18.9261L15.4531 18.9045L15.453 18.9027L15.1907 18.9261ZM11.9474 11.7524H11.6841V11.8981L11.8076 11.9755L11.9474 11.7524ZM11.9474 11.7347L11.7008 11.6422L11.6841 11.6869V11.7347H11.9474ZM12.8319 9.3759L13.0784 9.46835L13.0786 9.46806L12.8319 9.3759ZM12.0034 8.18176L12.0034 7.91846H12.0034V8.18176ZM7.28579 8.18176V7.91846H7.28577L7.28579 8.18176ZM6.45727 9.3759L6.21062 9.46806L6.21073 9.46835L6.45727 9.3759ZM7.34182 11.7347H7.60512V11.6869L7.58836 11.6422L7.34182 11.7347ZM7.34182 11.7524L7.48139 11.9757L7.60512 11.8983V11.7524H7.34182ZM4.09847 18.9261L4.3608 18.9488L4.36084 18.9483L4.09847 18.9261ZM4.62625 20.4829L4.8207 20.3053L4.82066 20.3053L4.62625 20.4829ZM6.15357 21.1551V20.8918L6.15317 20.8918L6.15357 21.1551ZM13.1268 21.1551L13.1272 20.8918H13.1268V21.1551ZM14.6541 20.4829L14.4607 20.3042L14.4596 20.3053L14.6541 20.4829ZM7.28873 9.06732V8.80401H6.90878L7.04219 9.15977L7.28873 9.06732ZM12.0063 9.06732L12.2529 9.15977L12.3863 8.80401H12.0063V9.06732ZM11.1218 11.4261V11.6894H11.3042L11.3683 11.5186L11.1218 11.4261ZM8.17328 11.4261L7.92674 11.5186L7.99081 11.6894H8.17328V11.4261ZM13.1327 20.2714V20.5347L13.1333 20.5347L13.1327 20.2714ZM6.16251 20.2714V20.0081L6.16177 20.0081L6.16251 20.2714ZM4.98311 19.0035L4.72081 18.9802L4.72055 18.9838L4.98311 19.0035ZM8.17043 12.3105V12.0472H8.11291L8.06063 12.0711L8.17043 12.3105ZM11.1189 12.3105L11.2295 12.0715L11.1769 12.0472H11.1189V12.3105ZM14.3062 19.0035L14.5688 18.9838L14.5685 18.9806L14.3062 19.0035ZM15.453 18.9027C15.3931 18.2308 15.2174 16.8142 14.7309 15.3586C14.247 13.9105 13.4401 12.377 12.0872 11.5293L11.8076 11.9755C13.005 12.7258 13.7608 14.1172 14.2315 15.5255C14.6996 16.9263 14.8704 18.2975 14.9284 18.9494L15.453 18.9027ZM12.2107 11.7524V11.7347H11.6841V11.7524H12.2107ZM12.1939 11.8271L13.0784 9.46835L12.5854 9.28345L11.7008 11.6422L12.1939 11.8271ZM13.0786 9.46806C13.2102 9.11564 13.1609 8.72107 12.9464 8.41197L12.5137 8.71217C12.6298 8.87946 12.6565 9.09301 12.5853 9.28375L13.0786 9.46806ZM12.9464 8.41197C12.7319 8.10287 12.3796 7.91849 12.0034 7.91846L12.0034 8.44507C12.207 8.44508 12.3977 8.54488 12.5137 8.71217L12.9464 8.41197ZM12.0034 7.91846H7.28579V8.44507H12.0034V7.91846ZM7.28577 7.91846C6.90956 7.91849 6.55725 8.10287 6.34278 8.41197L6.77545 8.71217C6.89152 8.54488 7.0822 8.44508 7.28582 8.44507L7.28577 7.91846ZM6.34278 8.41197C6.12832 8.72107 6.07894 9.11564 6.21062 9.46806L6.70392 9.28375C6.63265 9.09301 6.65938 8.87946 6.77545 8.71217L6.34278 8.41197ZM6.21073 9.46835L7.09528 11.8271L7.58836 11.6422L6.70381 9.28345L6.21073 9.46835ZM7.07851 11.7347V11.7524H7.60512V11.7347H7.07851ZM7.20224 11.5291C5.84627 12.3768 5.03781 13.9103 4.5538 15.3586C4.06732 16.8143 3.89305 18.2311 3.83611 18.9039L4.36084 18.9483C4.41594 18.2972 4.58517 16.9262 5.05326 15.5255C5.52383 14.1174 6.28102 12.7261 7.48139 11.9757L7.20224 11.5291ZM3.83615 18.9033C3.78039 19.5465 3.99641 20.1838 4.43185 20.6605L4.82066 20.3053C4.48451 19.9373 4.31774 19.4454 4.3608 18.9488L3.83615 18.9033ZM4.43181 20.6604C4.87358 21.1442 5.49881 21.4194 6.15398 21.4184L6.15317 20.8918C5.64626 20.8926 5.1625 20.6797 4.8207 20.3053L4.43181 20.6604ZM6.15357 21.4184H13.1268V20.8918H6.15357V21.4184ZM13.1264 21.4184C13.7815 21.4194 14.4068 21.1442 14.8485 20.6604L14.4596 20.3053C14.1178 20.6797 13.6341 20.8926 13.1272 20.8918L13.1264 21.4184ZM14.8474 20.6616C15.2865 20.1865 15.5062 19.5491 15.4531 18.9045L14.9283 18.9477C14.9693 19.4454 14.7997 19.9374 14.4607 20.3042L14.8474 20.6616ZM7.28873 9.33062H12.0063V8.80401H7.28873V9.33062ZM11.7598 8.97486L10.8752 11.3337L11.3683 11.5186L12.2529 9.15977L11.7598 8.97486ZM11.1218 11.1628H8.17328V11.6894H11.1218V11.1628ZM8.41982 11.3337L7.53527 8.97486L7.04219 9.15977L7.92674 11.5186L8.41982 11.3337ZM13.1327 20.0081H6.16251V20.5347H13.1327V20.0081ZM6.16177 20.0081C5.90642 20.0088 5.66235 19.9029 5.48843 19.716L5.10286 20.0746C5.37676 20.3691 5.76111 20.5358 6.16325 20.5347L6.16177 20.0081ZM5.48843 19.716C5.31451 19.529 5.22652 19.2779 5.24567 19.0233L4.72055 18.9838C4.69039 19.3848 4.82896 19.7802 5.10286 20.0746L5.48843 19.716ZM5.24538 19.0268C5.35289 17.8167 5.62653 16.4089 6.1239 15.1928C6.62409 13.9698 7.33205 12.9848 8.28023 12.5498L8.06063 12.0711C6.93307 12.5885 6.15646 13.722 5.63648 14.9934C5.11367 16.2717 4.83152 17.7343 4.72084 18.9802L5.24538 19.0268ZM8.17043 12.5738H11.1189V12.0472H8.17043V12.5738ZM11.0083 12.5494C11.9513 12.9859 12.6602 13.9713 13.1623 15.1942C13.6615 16.4101 13.9379 17.817 14.0439 19.0265L14.5685 18.9806C14.4593 17.734 14.1741 16.272 13.6494 14.9942C13.1276 13.7234 12.3505 12.5904 11.2295 12.0715L11.0083 12.5494ZM14.0437 19.0233C14.0628 19.2771 13.9754 19.5275 13.8025 19.7143L14.1889 20.072C14.4613 19.7778 14.5989 19.3835 14.5688 18.9838L14.0437 19.0233ZM13.8025 19.7143C13.6296 19.9011 13.3867 20.0075 13.1322 20.0081L13.1333 20.5347C13.5342 20.5338 13.9166 20.3662 14.1889 20.072L13.8025 19.7143Z"
                        ></path>
                      </svg>
                    </div>
                    <div class="ml-3">
                      <h6 class="mb-1 font-15 text-muted font-weight-normal">
                        Cash Collection:
                      </h6>
                      <h5 class="mb-0">$900.99</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                <div class="card no-shadow card-icon">
                  <div
                    class="card-body d-flex align-items-start border-left border-2 border-primary"
                  >
                    <div class="svg-box">
                      <svg
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          class="fill"
                          d="M22.5 1.875C22.9973 1.875 23.4742 2.07254 23.8258 2.42417C24.1775 2.77581 24.375 3.25272 24.375 3.75V26.25C24.375 26.7473 24.1775 27.2242 23.8258 27.5758C23.4742 27.9275 22.9973 28.125 22.5 28.125H7.5C7.00272 28.125 6.52581 27.9275 6.17417 27.5758C5.82254 27.2242 5.625 26.7473 5.625 26.25V3.75C5.625 3.25272 5.82254 2.77581 6.17417 2.42417C6.52581 2.07254 7.00272 1.875 7.5 1.875H22.5ZM7.5 0C6.50544 0 5.55161 0.395088 4.84835 1.09835C4.14509 1.80161 3.75 2.75544 3.75 3.75V26.25C3.75 27.2446 4.14509 28.1984 4.84835 28.9017C5.55161 29.6049 6.50544 30 7.5 30H22.5C23.4946 30 24.4484 29.6049 25.1516 28.9017C25.8549 28.1984 26.25 27.2446 26.25 26.25V3.75C26.25 2.75544 25.8549 1.80161 25.1516 1.09835C24.4484 0.395088 23.4946 0 22.5 0L7.5 0Z"
                        ></path>
                        <path
                          class="fill"
                          d="M10.9092 13.7188C11.0549 15.3596 12.3985 16.5241 14.4439 16.6747V17.8717H15.4706V16.6747C17.705 16.4985 19.091 15.2592 19.091 13.4264C19.091 11.8613 18.1588 10.9557 16.1813 10.4458L15.4706 10.2618V6.5193C16.575 6.62758 17.3202 7.22212 17.5082 8.10999H18.9552C18.7918 6.53505 17.4393 5.40503 15.4706 5.28002V4.09094H14.4439V5.30463C12.5353 5.53103 11.2252 6.75358 11.2252 8.4112C11.2252 9.84243 12.176 10.8553 13.8445 11.2825L14.4449 11.442V15.4098C13.3139 15.2425 12.5353 14.6224 12.3473 13.7188H10.9092ZM14.2471 9.94283C13.2204 9.68395 12.6721 9.13075 12.6721 8.35214C12.6721 7.42293 13.3651 6.73684 14.4439 6.55277V9.99303L14.2471 9.94382V9.94283ZM15.8132 11.7855C17.08 12.1035 17.6361 12.6311 17.6361 13.5268C17.6361 14.6066 16.8231 15.3262 15.4706 15.4354V11.6999L15.8132 11.7845V11.7855Z"
                        ></path>
                        <path
                          class="fill"
                          d="M15 26.25C15.4973 26.25 15.9742 26.0525 16.3258 25.7008C16.6775 25.3492 16.875 24.8723 16.875 24.375C16.875 23.8777 16.6775 23.4008 16.3258 23.0492C15.9742 22.6975 15.4973 22.5 15 22.5C14.5027 22.5 14.0258 22.6975 13.6742 23.0492C13.3225 23.4008 13.125 23.8777 13.125 24.375C13.125 24.8723 13.3225 25.3492 13.6742 25.7008C14.0258 26.0525 14.5027 26.25 15 26.25Z"
                        ></path>
                      </svg>
                    </div>
                    <div class="ml-3">
                      <h6 class="mb-1 font-15 text-muted font-weight-normal">
                        Mobile Money:
                      </h6>
                      <h5 class="mb-0">$0.00</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                <div class="card no-shadow card-icon">
                  <div
                    class="card-body d-flex align-items-start border-left border-2 border-primary"
                  >
                    <div class="svg-box">
                      <svg
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          class="fill"
                          d="M18.75 5.625C19.2473 5.625 19.7242 5.82254 20.0758 6.17417C20.4275 6.52581 20.625 7.00272 20.625 7.5V22.5C20.625 22.9973 20.4275 23.4742 20.0758 23.8258C19.7242 24.1775 19.2473 24.375 18.75 24.375H11.25C10.7527 24.375 10.2758 24.1775 9.92417 23.8258C9.57254 23.4742 9.375 22.9973 9.375 22.5V7.5C9.375 7.00272 9.57254 6.52581 9.92417 6.17417C10.2758 5.82254 10.7527 5.625 11.25 5.625H18.75ZM11.25 3.75C10.2554 3.75 9.30161 4.14509 8.59835 4.84835C7.89509 5.55161 7.5 6.50544 7.5 7.5V22.5C7.5 23.4946 7.89509 24.4484 8.59835 25.1517C9.30161 25.8549 10.2554 26.25 11.25 26.25H18.75C19.7446 26.25 20.6984 25.8549 21.4016 25.1517C22.1049 24.4484 22.5 23.4946 22.5 22.5V7.5C22.5 6.50544 22.1049 5.55161 21.4016 4.84835C20.6984 4.14509 19.7446 3.75 18.75 3.75H11.25Z"
                        ></path>
                        <path
                          class="fill"
                          d="M15 22.5001C15.4973 22.5001 15.9742 22.3025 16.3258 21.9509C16.6775 21.5993 16.875 21.1223 16.875 20.6251C16.875 20.1278 16.6775 19.6509 16.3258 19.2992C15.9742 18.9476 15.4973 18.7501 15 18.7501C14.5027 18.7501 14.0258 18.9476 13.6742 19.2992C13.3226 19.6509 13.125 20.1278 13.125 20.6251C13.125 21.1223 13.3226 21.5993 13.6742 21.9509C14.0258 22.3025 14.5027 22.5001 15 22.5001ZM2.99814 7.60881C3.10699 7.66641 3.20343 7.74488 3.28195 7.83976C3.36047 7.93464 3.41952 8.04405 3.45574 8.16176C3.49195 8.27947 3.50463 8.40316 3.49303 8.52576C3.48143 8.64837 3.44579 8.76748 3.38814 8.87631C2.3911 10.7633 1.87158 12.8659 1.87502 15.0001C1.87502 17.2126 2.42252 19.2976 3.38814 21.1238C3.5045 21.3436 3.52879 21.6006 3.45565 21.8383C3.38251 22.076 3.21794 22.2749 2.99814 22.3913C2.77834 22.5077 2.52132 22.532 2.28362 22.4588C2.04592 22.3857 1.847 22.2211 1.73064 22.0013C0.590685 19.8439 -0.00350165 17.4401 1.55239e-05 15.0001C1.55239e-05 12.4744 0.626266 10.0894 1.73064 7.99881C1.78824 7.88996 1.86671 7.79352 1.96159 7.715C2.05647 7.63648 2.16589 7.57743 2.28359 7.54121C2.4013 7.505 2.52499 7.49232 2.64759 7.50392C2.7702 7.51552 2.88931 7.55116 2.99814 7.60881ZM27.0019 7.60881C27.1107 7.55116 27.2298 7.51552 27.3524 7.50392C27.475 7.49232 27.5987 7.505 27.7164 7.54121C27.8341 7.57743 27.9436 7.63648 28.0384 7.715C28.1333 7.79352 28.2118 7.88996 28.2694 7.99881C29.4094 10.1562 30.0036 12.56 30 15.0001C30.0036 17.4401 29.4094 19.8439 28.2694 22.0013C28.153 22.2211 27.9541 22.3857 27.7164 22.4588C27.4787 22.532 27.2217 22.5077 27.0019 22.3913C26.7821 22.2749 26.6175 22.076 26.5444 21.8383C26.4712 21.6006 26.4955 21.3436 26.6119 21.1238C27.6089 19.2368 28.1285 17.1343 28.125 15.0001C28.125 12.7876 27.5775 10.7026 26.6119 8.87631C26.5542 8.76748 26.5186 8.64837 26.507 8.52576C26.4954 8.40316 26.5081 8.27947 26.5443 8.16176C26.5805 8.04405 26.6396 7.93464 26.7181 7.83976C26.7966 7.74488 26.893 7.66641 27.0019 7.60881ZM5.73189 10.3763C5.84668 10.4211 5.95151 10.488 6.04041 10.5733C6.12931 10.6586 6.20052 10.7606 6.24997 10.8734C6.29943 10.9863 6.32616 11.1078 6.32863 11.2309C6.33111 11.3541 6.30928 11.4766 6.26439 11.5913C5.84052 12.6777 5.62367 13.8339 5.62502 15.0001C5.62502 16.2038 5.85002 17.3532 6.26252 18.4088C6.31484 18.5247 6.34304 18.65 6.34541 18.7771C6.34779 18.9042 6.32428 19.0305 6.27631 19.1483C6.22835 19.266 6.15694 19.3728 6.06642 19.4621C5.9759 19.5513 5.86817 19.6213 5.74977 19.6676C5.63138 19.714 5.50479 19.7357 5.37771 19.7316C5.25064 19.7275 5.12573 19.6976 5.01058 19.6437C4.89543 19.5898 4.79245 19.513 4.7079 19.418C4.62335 19.3231 4.559 19.2119 4.51877 19.0913C4.00964 17.7874 3.74891 16.3998 3.75002 15.0001C3.75002 13.5582 4.02189 12.1782 4.51877 10.9088C4.60917 10.6774 4.7877 10.4914 5.01516 10.3916C5.24261 10.2917 5.50039 10.2862 5.73189 10.3763ZM24.2681 10.3763C24.3829 10.3314 24.5053 10.3096 24.6285 10.3121C24.7517 10.3145 24.8732 10.3413 24.986 10.3907C25.0989 10.4402 25.2008 10.5114 25.2861 10.6003C25.3714 10.6892 25.4384 10.794 25.4831 10.9088C25.9781 12.1782 26.25 13.5582 26.25 15.0001C26.25 16.4419 25.9781 17.8219 25.4813 19.0913C25.3824 19.3104 25.2031 19.4831 24.9805 19.5737C24.7579 19.6644 24.509 19.6661 24.2851 19.5785C24.0613 19.4909 23.8797 19.3207 23.7778 19.103C23.6759 18.8853 23.6614 18.6368 23.7375 18.4088C24.15 17.3532 24.375 16.2038 24.375 15.0001C24.375 13.7963 24.15 12.6469 23.7375 11.5913C23.6468 11.3598 23.6517 11.1018 23.7512 10.8739C23.8507 10.6461 24.0367 10.4671 24.2681 10.3763Z"
                        ></path>
                      </svg>
                    </div>
                    <div class="ml-3">
                      <h6 class="mb-1 font-15 text-muted font-weight-normal">
                        Airtime:
                      </h6>
                      <h5 class="mb-0">$10.99</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                <div class="card no-shadow card-icon">
                  <div
                    class="card-body d-flex align-items-start border-left border-2 border-primary"
                  >
                    <div class="svg-box">
                      <svg
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          class="fill"
                          d="M14.9965 13.2857C10.7973 13.2857 6.58412 12.5324 4.28223 10.9141V13.2857C4.28223 15.2528 9.08133 16.8571 14.9965 16.8571C20.9117 16.8571 25.7108 15.2528 25.7108 13.2857V10.9141C23.4089 12.5324 19.1957 13.2857 14.9965 13.2857ZM14.9965 24C10.7973 24 6.58412 23.2467 4.28223 21.6283V24C4.28223 25.9671 9.08133 27.5714 14.9965 27.5714C20.9117 27.5714 25.7108 25.9671 25.7108 24V21.6283C23.4089 23.2467 19.1957 24 14.9965 24ZM14.9965 18.6429C10.7973 18.6429 6.58412 17.8895 4.28223 16.2712V18.6429C4.28223 20.6099 9.08133 22.2143 14.9965 22.2143C20.9117 22.2143 25.7108 20.6099 25.7108 18.6429V16.2712C23.4089 17.8895 19.1957 18.6429 14.9965 18.6429ZM14.9965 2.57143C9.08133 2.57143 4.28223 4.17578 4.28223 6.14286V7.92857C4.28223 9.89565 9.08133 11.5 14.9965 11.5C20.9117 11.5 25.7108 9.89565 25.7108 7.92857V6.14286C25.7108 4.17578 20.9117 2.57143 14.9965 2.57143Z"
                        />
                      </svg>
                    </div>
                    <div class="ml-3">
                      <h6 class="mb-1 font-15 text-muted font-weight-normal">
                        Data:
                      </h6>
                      <h5 class="mb-0">$10,033.99</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                <div class="card no-shadow card-icon">
                  <div
                    class="card-body d-flex align-items-start border-left border-2 border-primary"
                  >
                    <div class="svg-box">
                      <i class="fa fa fa-ticket font-30 text-white"></i>
                    </div>
                    <div class="ml-3">
                      <h6 class="mb-1 font-15 text-muted font-weight-normal">
                        Other:
                      </h6>
                      <h5 class="mb-0">$33.99</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <main-loader ref="loader"></main-loader>
  </div>
</template>
<script>
import "@/plugins/sweetalert2";
import "@/plugins/vee-validate";
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
import Multiselect from "vue-multiselect";
// const moment = require('moment')
export default {
  name: "TransactionListComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    Datepicker: () => import("vuejs-datepicker"),
    Multiselect,
    "main-loader": LoaderComponent,
  },
  methods: {
    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = e.target.value;
        }
      }
    },

    // showEdit(data){
    //     console.log(data);
    //     this.$router.push({ path: '/customer/edit' })
    // }
  },
  data() {
    return {
      items: [
        {
          srccountry: { flagClass: "flag-icon flag-icon-gb fi-lg fi-round" },
          datetime: { date: "16-Nov-2022", time: "06:50pm GMT" },
          sender: {
            name: "ABURI GIRLS OLD GIRLS ASSOCIATION",
            group: "Bronze",
          },
          recver: { name: "Potters City" },
          accno: {
            type: "fa fa-bank",
            acc: "Bank of Africa",
            no: "12345678914589",
          },
          refno: { ref: "PA00036403235", class: "fa fa-apple" },
          srcamount: { amount: "$5,000.00", destamount: "₦25,000.43" },
          status: { name: "Awaiting Funds", class: "badge-success" },
          processor: "-",
          action: { name: "Awaiting Funds" },
        },
        {
          srccountry: { flagClass: "flag-icon flag-icon-gh fi-lg fi-round" },
          datetime: { date: "16-Nov-2022", time: "06:50pm GMT" },
          sender: {
            name: "ABURI GIRLS OLD GIRLS ASSOCIATION",
            group: "Silver",
          },
          recver: { name: "Students Loan Trust Fund" },
          accno: {
            type: "fa fa-mobile fa-lg",
            acc: "MTN",
            no: "+233599536281",
          },
          refno: { ref: "PA00031603234", class: "fa fa-android" },
          srcamount: { amount: "$5.00", destamount: "R25.43" },
          status: { name: "Recipient Paid", class: "badge-success" },
          processor: "GT",
          action: { name: "Recipient Paid" },
        },
        {
          srccountry: { flagClass: "flag-icon flag-icon-us fi-lg fi-round" },
          datetime: { date: "15-Nov-2022", time: "06:50pm GMT" },
          sender: {
            name: "ABURI GIRLS OLD GIRLS ASSOCIATION",
            group: "SilverPlus",
          },
          recver: { name: "Potters City" },
          accno: {
            type: "fa fa-mobile fa-lg",
            acc: "Vodafone",
            no: "+233599536281",
          },
          refno: { ref: "PA00031603234", class: "fa fa-globe" },
          srcamount: { amount: "$5.00", destamount: "¢25.43" },
          status: { name: "Incomplete", class: "badge-warning" },
          processor: "-",
          action: { name: "Incomplete" },
        },
        {
          srccountry: { flagClass: "flag-icon flag-icon-gb fi-lg fi-round" },
          datetime: { date: "14-Nov-2022", time: "06:50pm GMT" },
          sender: {
            name: "ABURI GIRLS OLD GIRLS ASSOCIATION",
            group: "Bronze",
          },
          recver: { name: "Students Loan Trust Fund" },
          accno: {
            type: "fa fa-bank",
            acc: "Bank of Africa",
            no: "12345678914589",
          },
          refno: { ref: "PA00036403235", class: "fa fa-user" },
          srcamount: { amount: "$5.00", destamount: "¢25.43" },
          status: { name: "Cancelled", class: "badge-danger" },
          processor: "-",
          action: { name: "Cancelled" },
        },
        {
          srccountry: { flagClass: "flag-icon flag-icon-gb fi-lg fi-round" },
          datetime: { date: "03-Nov-2022", time: "06:50pm GMT" },
          sender: {
            name: "ABURI GIRLS OLD GIRLS ASSOCIATION",
            group: "Silver",
          },
          recver: { name: "Jerry Amegbor" },
          accno: {
            type: "fa fa-mobile fa-lg",
            acc: "Vodafone",
            no: "+233599536281",
          },
          refno: { ref: "PA00031603234", class: "fa fa-globe" },
          srcamount: { amount: "$5.00", destamount: "₦25.43" },
          status: { name: "Created", class: "badge-warning" },
          processor: "-",
          action: { name: "Created" },
        },
        {
          srccountry: { flagClass: "flag-icon flag-icon-gb fi-lg fi-round" },
          datetime: { date: "16-Nov-2022", time: "06:50pm GMT" },
          sender: {
            name: "ABURI GIRLS OLD GIRLS ASSOCIATION",
            group: "Bronze",
          },
          recver: { name: "Potters City" },
          accno: {
            type: "fa fa-bank",
            acc: "Bank of Africa",
            no: "12345678914589",
          },
          refno: { ref: "PA00036403235", class: "fa fa-apple" },
          srcamount: { amount: "$5,000.00", destamount: "R5,000.43" },
          status: { name: "Awaiting Funds", class: "badge-success" },
          processor: "-",
          action: { name: "Awaiting Funds" },
        },
        {
          srccountry: { flagClass: "flag-icon flag-icon-gh fi-lg fi-round" },
          datetime: { date: "16-Nov-2022", time: "06:50pm GMT" },
          sender: {
            name: "ABURI GIRLS OLD GIRLS ASSOCIATION",
            group: "Silver",
          },
          recver: { name: "Students Loan Trust Fund" },
          accno: {
            type: "fa fa-mobile fa-lg",
            acc: "MTN",
            no: "+233599536281",
          },
          refno: { ref: "PA00031603234", class: "fa fa-android" },
          srcamount: { amount: "$5.00", destamount: "£25.43" },
          status: { name: "Sent for Payment", class: "badge-success" },
          processor: "-",
          action: { name: "Sent for Payment" },
        },
        {
          srccountry: { flagClass: "flag-icon flag-icon-us fi-lg fi-round" },
          datetime: { date: "15-Nov-2022", time: "06:50pm GMT" },
          sender: {
            name: "ABURI GIRLS OLD GIRLS ASSOCIATION",
            group: "SilverPlus",
          },
          recver: { name: "Potters City" },
          accno: {
            type: "fa fa-mobile fa-lg",
            acc: "AIRTEL",
            no: "+233599536281",
          },
          refno: { ref: "PA00031603234", class: "fa fa-globe" },
          srcamount: { amount: "$5.00", destamount: "£25.43" },
          status: { name: "Incomplete", class: "badge-warning" },
          processor: "-",
          action: { name: "Incomplete" },
        },
        {
          srccountry: { flagClass: "flag-icon flag-icon-gb fi-lg fi-round" },
          datetime: { date: "14-Nov-2022", time: "06:50pm GMT" },
          sender: {
            name: "ABURI GIRLS OLD GIRLS ASSOCIATION",
            group: "Bronze",
          },
          recver: { name: "Students Loan Trust Fund" },
          accno: {
            type: "fa fa-bank",
            acc: "Bank of Africa",
            no: "12345678914589",
          },
          refno: { ref: "PA00036403235", class: "fa fa-user" },
          srcamount: { amount: "$5.00", destamount: "£25.43" },
          status: { name: "Cancelled", class: "badge-danger" },
          processor: "-",
          action: { name: "Cancelled" },
        },
        {
          srccountry: { flagClass: "flag-icon flag-icon-gh fi-lg fi-round" },
          datetime: { date: "03-Nov-2022", time: "06:50pm GMT" },
          sender: {
            name: "ABURI GIRLS OLD GIRLS ASSOCIATION",
            group: "Silver",
          },
          recver: { name: "Jerry Amegbor" },
          accno: {
            type: "fa fa-mobile fa-lg",
            acc: "AIRTEL",
            no: "+233599536281",
          },
          refno: { ref: "PA00031603234", class: "fa fa-globe" },
          srcamount: { amount: "$5.00", destamount: "£25.43" },
          status: { name: "Created", class: "badge-warning" },
          processor: "-",
          action: { name: "Created" },
        },
        {
          srccountry: { flagClass: "flag-icon flag-icon-gb fi-lg fi-round" },
          datetime: { date: "16-Nov-2022", time: "06:50pm GMT" },
          sender: {
            name: "ABURI GIRLS OLD GIRLS ASSOCIATION",
            group: "Bronze",
          },
          recver: { name: "Potters City" },
          accno: {
            type: "fa fa-bank",
            acc: "Bank of Africa",
            no: "12345678914589",
          },
          refno: { ref: "PA00036403235", class: "fa fa-apple" },
          srcamount: { amount: "$5,000.00", destamount: "£25,000.43" },
          status: { name: "Awaiting Funds", class: "badge-success" },
          processor: "-",
          action: { name: "Awaiting Funds" },
        },
        {
          srccountry: { flagClass: "flag-icon flag-icon-gh fi-lg fi-round" },
          datetime: { date: "16-Nov-2022", time: "06:50pm GMT" },
          sender: {
            name: "ABURI GIRLS OLD GIRLS ASSOCIATION",
            group: "Silver",
          },
          recver: { name: "Students Loan Trust Fund" },
          accno: {
            type: "fa fa-mobile fa-lg",
            acc: "AIRTEL",
            no: "+233599536281",
          },
          refno: { ref: "PA00031603234", class: "fa fa-android" },
          srcamount: { amount: "$5.00", destamount: "£25.43" },
          status: { name: "Sent for Payment", class: "badge-success" },
          processor: "-",
          action: { name: "Sent for Payment" },
        },
        {
          srccountry: { flagClass: "flag-icon flag-icon-us fi-lg fi-round" },
          datetime: { date: "16-Nov-2022", time: "06:50pm GMT" },
          sender: {
            name: "ABURI GIRLS OLD GIRLS ASSOCIATION",
            group: "SilverPlus",
          },
          recver: { name: "Potters City" },
          accno: {
            type: "fa fa-mobile fa-lg",
            acc: "AIRTEL",
            no: "+233599536281",
          },
          refno: { ref: "PA00031603234", class: "fa fa-globe" },
          srcamount: { amount: "$5.00", destamount: "£25.43" },
          status: { name: "Incomplete", class: "badge-warning" },
          processor: "-",
          action: { name: "Incomplete" },
        },
        {
          srccountry: { flagClass: "flag-icon flag-icon-gb fi-lg fi-round" },
          datetime: { date: "14-Nov-2022", time: "06:50pm GMT" },
          sender: {
            name: "ABURI GIRLS OLD GIRLS ASSOCIATION",
            group: "Bronze",
          },
          recver: { name: "Students Loan Trust Fund" },
          accno: {
            type: "fa fa-bank",
            acc: "Bank of Africa",
            no: "12345678914589",
          },
          refno: { ref: "PA00036403235", class: "fa fa-user" },
          srcamount: { amount: "$5.00", destamount: "£25.43" },
          status: { name: "Cancelled", class: "badge-danger" },
          processor: "-",
          action: { name: "Cancelled" },
        },
        {
          srccountry: { flagClass: "flag-icon flag-icon-gh fi-lg fi-round" },
          datetime: { date: "03-Nov-2022", time: "06:50pm GMT" },
          sender: {
            name: "ABURI GIRLS OLD GIRLS ASSOCIATION",
            group: "Silver",
          },
          recver: { name: "Jerry Amegbor" },
          accno: {
            type: "fa fa-mobile fa-lg",
            acc: "AIRTEL",
            no: "+233599536281",
          },
          refno: { ref: "PA00031603234", class: "fa fa-globe" },
          srcamount: { amount: "$5.00", destamount: "£25.43" },
          status: { name: "Created", class: "badge-warning" },
          processor: "-",
          action: { name: "Created" },
        },
        {
          srccountry: { flagClass: "flag-icon flag-icon-gb fi-lg fi-round" },
          datetime: { date: "16-Nov-2022", time: "06:50pm GMT" },
          sender: {
            name: "ABURI GIRLS OLD GIRLS ASSOCIATION",
            group: "Bronze",
          },
          recver: { name: "Potters City" },
          accno: {
            type: "fa fa-bank",
            acc: "Bank of Africa",
            no: "12345678914589",
          },
          refno: { ref: "PA00036403235", class: "fa fa-apple" },
          srcamount: { amount: "$5,000.00", destamount: "£25,000.43" },
          status: { name: "Awaiting Funds", class: "badge-success" },
          processor: "-",
          action: { name: "Awaiting Funds" },
        },
        {
          srccountry: { flagClass: "flag-icon flag-icon-gh fi-lg fi-round" },
          datetime: { date: "16-Nov-2022", time: "06:50pm GMT" },
          sender: {
            name: "ABURI GIRLS OLD GIRLS ASSOCIATION",
            group: "Silver",
          },
          recver: { name: "Students Loan Trust Fund" },
          accno: {
            type: "fa fa-mobile fa-lg",
            acc: "MTN",
            no: "+233599536281",
          },
          refno: { ref: "PA00031603234", class: "fa fa-android" },
          srcamount: { amount: "$5.00", destamount: "£25.43" },
          status: { name: "Sent for Payment", class: "badge-success" },
          processor: "-",
          action: { name: "Sent for Payment" },
        },
        {
          srccountry: { flagClass: "flag-icon flag-icon-us fi-lg fi-round" },
          datetime: { date: "15-Nov-2022", time: "06:50pm GMT" },
          sender: {
            name: "ABURI GIRLS OLD GIRLS ASSOCIATION",
            group: "SilverPlus",
          },
          recver: { name: "Potters City" },
          accno: {
            type: "fa fa-mobile fa-lg",
            acc: "Vodafone",
            no: "+233599536281",
          },
          refno: { ref: "PA00031603234", class: "fa fa-globe" },
          srcamount: { amount: "$5.00", destamount: "£25.43" },
          status: { name: "Incomplete", class: "badge-warning" },
          processor: "-",
          action: { name: "Incomplete" },
        },
        {
          srccountry: { flagClass: "flag-icon flag-icon-gb fi-lg fi-round" },
          datetime: { date: "14-Nov-2022", time: "06:50pm GMT" },
          sender: {
            name: "ABURI GIRLS OLD GIRLS ASSOCIATION",
            group: "Bronze",
          },
          recver: { name: "Students Loan Trust Fund" },
          accno: {
            type: "fa fa-bank",
            acc: "Bank of Africa",
            no: "12345678914589",
          },
          refno: { ref: "PA00036403235", class: "fa fa-user" },
          srcamount: { amount: "$5.00", destamount: "£25.43" },
          status: { name: "Recipient Paid", class: "badge-success" },
          processor: "NSANO",
          action: { name: "Recipient Paid" },
        },
        {
          srccountry: { flagClass: "flag-icon flag-icon-gh fi-lg fi-round" },
          datetime: { date: "03-Nov-2022", time: "06:50pm GMT" },
          sender: {
            name: "ABURI GIRLS OLD GIRLS ASSOCIATION",
            group: "Silver",
          },
          recver: { name: "Jerry Amegbor" },
          accno: {
            type: "fa fa-mobile fa-lg",
            acc: "Vodafone",
            no: "+233599536281",
          },
          refno: { ref: "PA00031603234", class: "fa fa-globe" },
          srcamount: { amount: "$5.00", destamount: "£25.43" },
          status: { name: "Created", class: "badge-warning" },
          processor: "-",
          action: { name: "Created" },
        },
      ],

      fields: [
        {
          key: "srccountry",
          label: "S.C.",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "datetime",
          label: "Date",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "sender",
          label: "Sender",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "recver",
          label: "Receiver",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "accno",
          label: "Account No.",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "refno",
          label: "TransID",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "srcamount",
          label: "Src Amount",
          sortable: true,
          thClass: "th_sortfix text-right",
        },
        // { key: 'destamount', label: 'Src Amount', sortable: true, thClass: 'th_sortfix text-right' },
        {
          key: "status",
          label: "Trans. Status",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "processor",
          label: "Processor",
          sortable: true,
          thClass: "th_sortfix",
        },
        { key: "action", label: "Action", thClass: "th_sortfix" },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],

      totalRows: 1,
      currentPage: 1,
      perPage: 50,
      pageOptions: [50, 100, 150, 200, { value: 1000, text: 1000 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      // newMemberUrl: window.location.origin+'/members-form/members-form.html',
      uploadMember: {
        csvExcelFile: null,
      },

      isVisibleFilter: false,

      search: {
        from: "",
        to: "",
        tstatus: "",
        type: "",
        companyname: "",
        keywords: "",
        mobileMoneyNetwork: "",
        bankName: "",
      },

      transactionStatus: [
        "Transaction Incomplete",
        "Awaiting Funds",
        "Pending Authorisation",
        "Created",
        "Sent for Payment",
        "Beneficiary Paid",
        "Deleted or Cancelled",
        "Aborted",
        "Card Declined",
      ],
      typeoption: ["Customer", "Partner"],
    };
  },
  mounted() {
    this.totalRows = this.items.length;
  },
};
</script>
<style>
text-grey {
  color: #8a8a8a !important;
}
</style>
